import Env from '../base/env'
import gsap from 'gsap'

export default class FakeScroll
{
  constructor()
  {
    this.$reference = document.getElementById('fakeScroll--view')
    this.$progress = document.querySelector('.jsProgress')
    //
    this.ratio = 0
    this.newRatio = 0
    this.raf = false
  }

  lerp(a, b, n) {
    return (1 - n) * a + n * b
  }

  setup()
  {
    this.watch()
  }

  watch()
  {
    this.raf = requestAnimationFrame(()=>{

      const scrollInfo = Env.framework.toolbox.scrollPosition()
      const getRatio = scrollInfo.scrollY / scrollInfo.fullPageHeight
      if(Number.isNaN(getRatio) == false) {
        this.ratio = getRatio
        if(this.ratio > .9) {
          if(Env.$html.classList.contains('endpage--isComing') == false) {
            Env.$html.classList.add('endpage--isComing')
          }

        } else {
          if(Env.$html.classList.contains('endpage--isComing') == true) {
            Env.$html.classList.remove('endpage--isComing')
          }
        }
        this.newRatio = this.lerp(this.ratio, this.newRatio,.9)
        gsap.set(this.$progress , { scaleX : this.newRatio })
      }
      this.watch()
    })
  }
}
